import { TENANT_KEY } from './tenant'

export interface WelcomeCopy {
  eyebrow: string
  text: string
}

/** Wave-6 §3 (D4): landing welcome copy per tenant. Core default = null = NO panel —
 *  real tenants never see fictional prose. Unknown keys resolve null without throwing:
 *  copy is cosmetic; boot-time key validity is the corpus seam's job (knowledge/index).
 *  NUMBER-FREE by contract — figures come from live data only (advisor-corpus rule). */
const WELCOME_BY_TENANT: Record<string, WelcomeCopy> = {
  greencrate: {
    eyebrow: 'Welcome',
    text: 'GreenCrate delivers weekly fresh-food boxes to subscribers across Germany. This dashboard is the marketing-mix view of that business: how media spend converts into new subscriptions, reorders and net sales, measured daily by our MMM. The five pinned findings below are a guided tour — start at the top with the channel-efficiency story.',
  },
}

export const WELCOME: WelcomeCopy | null =
  TENANT_KEY !== null ? (WELCOME_BY_TENANT[TENANT_KEY] ?? null) : null
